import { createContext, useContext, useState, ReactNode } from "react";

interface NavbarLogoContextType {
  heroLogoVisible: boolean;
  setHeroLogoVisible: (visible: boolean) => void;
}

const NavbarLogoContext = createContext<NavbarLogoContextType | undefined>(undefined);

export const NavbarLogoProvider = ({ children }: { children: ReactNode }) => {
  const [heroLogoVisible, setHeroLogoVisible] = useState(true);
  
  return (
    <NavbarLogoContext.Provider value={{ heroLogoVisible, setHeroLogoVisible }}>
      {children}
    </NavbarLogoContext.Provider>
  );
};

export const useNavbarLogo = () => {
  const context = useContext(NavbarLogoContext);
  if (!context) {
    // Retourne un état par défaut si pas de provider (autres pages)
    return { heroLogoVisible: false, setHeroLogoVisible: () => {} };
  }
  return context;
};
